export default __webpack_public_path__ + "118def0e4816cf807bab2887b81f5a81.png";